(function () {
  function initNewBlogCarousel(section) {
    if (!section) return;

    var list = section.querySelector(".nb-carousel-list");
    var prev = section.querySelector(".nb-nav-prev");
    var next = section.querySelector(".nb-nav-next");
    var scrollbar = section.querySelector(".nb-custom-scrollbar");
    var drag = section.querySelector(".nb-custom-scrollbar-drag");

    if (!list || !prev || !next || !scrollbar || !drag) return;

    function updateScrollbar() {
      var sw = list.scrollWidth;
      var cw = list.clientWidth;
      var sl = list.scrollLeft;
      var sbw = scrollbar.clientWidth;

      if (sw <= cw) {
        drag.style.width = "0px";
        drag.style.transform = "translateX(0px)";
        return;
      }

      var dw = Math.max((cw / sw) * sbw, 30);
      var dl = (sl / (sw - cw)) * (sbw - dw);

      drag.style.width = dw + "px";
      drag.style.transform = "translateX(" + dl + "px)";
    }

    function showPrev() {
      if (window.innerWidth > 600) {
        prev.style.display = "flex";
      }
    }

    next.addEventListener("click", function () {
      list.scrollBy({ left: -300, behavior: "smooth" });
      showPrev();
      updateScrollbar();
    });

    prev.addEventListener("click", function () {
      list.scrollBy({ left: 300, behavior: "smooth" });
      updateScrollbar();
    });

    list.addEventListener("scroll", function () {
      showPrev();
      updateScrollbar();
    });

    var dragging = false;
    var startX = 0;
    var startSL = 0;
    var moved = false;

    function startDrag(e) {
      dragging = true;
      moved = false;
      startX = e.pageX;
      startSL = list.scrollLeft;
      list.style.cursor = "grabbing";
      e.preventDefault();
    }

    function doDrag(e) {
      if (!dragging) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 5) moved = true;
      list.scrollLeft = startSL - dx;
      showPrev();
      updateScrollbar();
    }

    function stopDrag() {
      dragging = false;
      list.style.cursor = "grab";
    }

    list.addEventListener("mousedown", startDrag);

    list.querySelectorAll("img").forEach(function (img) {
      img.addEventListener("mousedown", startDrag);
    });

    document.addEventListener("mousemove", doDrag);
    document.addEventListener("mouseup", stopDrag);

    list.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function (e) {
        if (moved) e.preventDefault();
      });
    });

    var scrollbarDragging = false;
    var startScrollX = 0;
    var startScrollLeft = 0;

    drag.addEventListener("mousedown", function (e) {
      scrollbarDragging = true;
      startScrollX = e.pageX;
      startScrollLeft = list.scrollLeft;
      document.body.style.userSelect = "none";
    });

    document.addEventListener("mouseup", function () {
      scrollbarDragging = false;
      document.body.style.userSelect = "auto";
    });

    document.addEventListener("mousemove", function (e) {
      if (!scrollbarDragging) return;

      var dx = e.pageX - startScrollX;
      var sw = list.scrollWidth - list.clientWidth;
      var sbw = scrollbar.clientWidth - drag.clientWidth;

      if (sbw <= 0) return;

      var delta = (dx / sbw) * sw;
      list.scrollLeft = startScrollLeft + delta;
      showPrev();
      updateScrollbar();
    });

    scrollbar.addEventListener("mousedown", function (e) {
      if (e.target === drag) return;

      var rect = scrollbar.getBoundingClientRect();
      var clickX = e.clientX - rect.left;
      var center = drag.offsetLeft + drag.offsetWidth / 2;

      var sw = list.scrollWidth - list.clientWidth;
      var sbw = scrollbar.clientWidth - drag.offsetWidth;

      if (sbw <= 0) return;

      var delta = ((clickX - center) / sbw) * sw;
      list.scrollBy({ left: delta, behavior: "smooth" });
      showPrev();
      updateScrollbar();
    });

    updateScrollbar();
  }

  function initAll() {
    document.querySelectorAll("#new-blog-carousel").forEach(function (section) {
      initNewBlogCarousel(section);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initNewBlogCarousel(event.target.querySelector("#new-blog-carousel"));
  });
})();
